<template lang="pug">
el-dialog(v-dialogDrag title="导入设置" :visible.sync="importDialog" width="600px" :before-close="handleClose")
  .content-midd
    el-table(ref="columnList" highlight-current-row size="small" height="400" @selection-change="handleSelectionChange"
      :data="columnList" row-key="metaId" border )
      el-table-column(type="selection" width="55" align="center")
      el-table-column(label="移动" width="50" align="center")
        i.iconfont.icon-drag.drag-option
      el-table-column(label="字段名称"  prop="columnName" )
      el-table-column(label="显示名称"  prop="columnDisplayName" )
      el-table-column(label="列宽" align="center" v-slot="{row,rowIndex}")
        el-input(v-model="row.importColumnWidth" type="number" size="small")
  .custom
    span 自定义处理器:
    el-input(v-model="customizeProcessBean" size="small")
  .tips 说明：自定义处理器可在数据入库前或后，对数据进行处理<br/>必需实现接口 IDynDatalmportAction,并注册到 spring 容器中
  div(slot="footer")
    el-button(@click="handleClose" size="small") 取 消
    el-button(type="primary" @click="onSubmit" :disabled="multipleSelection.length===0" size="small") 生成并下载模板
</template>

<script>
import Sortable from 'sortablejs';
import flowService from "@/CommonDP/service/flow-service";
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableName: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      importDialog: false,
      columnList: [],
      customizeProcessBean: "", // 自定义处理器
      multipleSelection: []
    };
  },
  mounted () {

  },
  methods: {
    async openDialog() {
      this.columnList = this.tableData;
      this.importDialog = true;
      await this.$nextTick();
      this.$refs.columnList.clearSelection();
      this.pullSort(); // 声明表格拖动排序方法
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 生成并下载模板
    onSubmit() {
      this.$confirm(`是否保存选择的数据做导入设置?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const { customizeProcessBean, tableName, multipleSelection } = this;
        const checkList = multipleSelection.map(e => e.metaId);
        const columnList = this.columnList.map(e => {
          return {
            importColumnWidth: Number(e.importColumnWidth),
            metaColumnId: e.metaId,
            isImport: checkList.some(i => i === e.metaId) ? 1 : 0
          };
        });
        const params = {
          columnList,
          customizeProcessBean,
          tableName
        };
        await flowService.importSave(params);
        await this.downloadTem();
        this.$refs.columnList.clearSelection();
        this.$success("操作成功");
        this.importDialog = false;
      }).catch((error) => {
        console.log(error);
      });
      // console.log(this.multipleSelection);
      // importSave
    },
    // 下载
    downloadTem() {
      const url = flowService.templateDownload(this.tableName);
      window.open(url, "_blank");
    },
    handleClose() {
      this.importDialog = false;
    },
    // 表格拖动排序方法
    pullSort() {
      // 通过ref获取Dom节点
      const el = this.$refs.columnList.$el.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      this.sortable = Sortable.create(el, {
        animation: 200, // 拖拽动画(毫秒)
        handle: ".drag-option",
        setData: function (dataTransfer) {
          dataTransfer.setData("Text", "");
        },
        // 结束拖拽
        onEnd: (e) => {
          // e.oldIndex为拖动一行原来的位置；e.newIndex为拖动后新的位置
          const oldRow = this.columnList[e.oldIndex]; // 移动元素集合
          const newRow = this.columnList[e.newIndex]; // 新的元素集合
          console.log(oldRow, "移动元素集合");
          console.log(newRow, "新的元素集合");
          // 调用接口传参即可
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.custom {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    font-size: 14px;
    width: 120px;
  }
}

.tips {
  color: #888;
  font-size: 0.8em;
}

.drag-option {
  cursor: pointer;
}
</style>
